import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyAveau-reSkn7hjn4Tm4iGxu96X6hUzqQs",
    authDomain: "creed-16390.firebaseapp.com",
    projectId: "creed-16390",
    storageBucket: "creed-16390.appspot.com",
    messagingSenderId: "617700199589",
    appId: "1:617700199589:web:5ad8ac971cd745a84f514c",
    measurementId: "G-ZHZB7V645F"
};

if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
}

export const auth = firebase.auth();
export const firestore = firebase.firestore();
export const storage = firebase.storage();
export const arrayUnion = firebase.firestore;

export const Timestamp = firebase.firestore.FieldValue.serverTimestamp();
